

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SignupformService } from './../services/signupform.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DecimalPipe } from '@angular/common';
import Swal from 'sweetalert2';
import { environment } from '../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { strings } from '../../assets/languageStrings';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrl: './payments.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [DecimalPipe]
})


export class PaymentsComponent {

  public paymentSucessResponse: boolean = false;
  public paymenttransactionResponse: boolean = false;

  public subscriptiondetails: any;
  public visible = false;
  public showbuttons = false
  public lang: any = {}
  public languageTokensArray: any = [];
  public countries = []
  public plansummaryMain: any
  public plansummary: any
  public plansummaryLIFE: any
  public provisioning: any = false;
  public currency: any;
  public currencySymbol: any;
  public uploadfile: any;
  public demovalue: any;
  public responsevalue: any;
  public failedarray: any = []
  showEnrollmentModel = false
  showHeaderMessage: any
  showModelContent: any
  customerLink: any;
  ShowModelPopup = false;
  ShowModelPopupTitle: any;
  ShowModelPopupMessage: any;
  iafgPlansAvailability: boolean = false;
  plansummaryLIFEFinal: any = [];
  public selectedLanguage: any;
  languageData: any;
  constructor(private _SignupformService: SignupformService, private Shared: SharedService, private _sanitizer: DomSanitizer, public router: Router, private route: ActivatedRoute, private _decimalPipe: DecimalPipe, private http: HttpClient) { }

  ngOnInit(): void {
    this.getLanguageTokens()
    sessionStorage.setItem("pageName", "Signup Process");
    this.postAnalyticsData();
    setInterval(() => {
      this.postAnalyticsData();
    }, 30000);
    let personalInfo = JSON.parse(sessionStorage.getItem("Data") || '[]')

    if (personalInfo) {
      // setTimeout(() => {
      //   // let formLink = sessionStorage.getItem("formlink");

      //   let formLink = 'SHZMOxgC0301';
      //           this._SignupformService
      // .getDataConfig(formLink)
      // .subscribe(
      //   (result: any) => {
      //     // this.isLoaded =true

      //     if (result.status == "200") {


      //       this.languageTokensArray =
      //         result.data.language_details.languageTokens;

      //       this.lang = {};

      //       for (let token of this.languageTokensArray) {
      //         this.lang[token.key] = token.value;

      //         // //this.consoleMessage(this.lang)
      //       }




      //     } else {
      //       this.ShowModelPopup =true
      //       this.ShowModelPopupMessage =result.message ? result.message : result.error,
      //       this.ShowModelPopupTitle =this.lang.Info


      //     }
      //   },
      //   (error) => {
      //     if([0,500,501,502,503].includes(error.status)){
      //       this.ShowModelPopup =true
      //       this.ShowModelPopupMessage ="Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience."
      //       this.ShowModelPopupTitle =this.lang.Info
      //     }
      //     else{

      //       this.ShowModelPopup =true
      //       this.ShowModelPopupMessage =error.error.message
      //       ? error.error.message
      //       : error.error.error,
      //       this.ShowModelPopupTitle =this.lang.Info

      //   }

      //   }
      // )


      // }, 2000);

      this.uploadfile = this.Shared.getMessage()

      this.subscriptiondetails = sessionStorage.getItem("subscriptionresult")

      this.route.queryParams.subscribe(params => {


        // let v5Api = sessionStorage.getItem('v5Api') == 'true' ? true : false;
        let v5Api = true;
        if (sessionStorage.getItem("paymentMethod") == "CC") {
          let authorizenetPaymentId = sessionStorage.getItem('authorizenetPaymentId') ?? 0;
          if (params['success'] == "True") {

            this.paymenttransactionResponse = true
            this.visible = true
            this.showbuttons = false
            sessionStorage.setItem("failed", "")
            let inputData = JSON.parse(sessionStorage.getItem("Data") || '[]');

            let enrollmentData = {
              "customerName": inputData.firstName + "" + inputData.lastName,
              "contactNum": inputData.phone_number,
              "dob": inputData.date_of_birth,
              "email": inputData.email,
              "process": "enrollmentSummary",
              "request": { "paymentMethod": "CC", "signature": sessionStorage.getItem("signature") || "", "paymentMethodId": v5Api == true ? authorizenetPaymentId : params['paymentMethodId'] }
            }

            this._SignupformService.savePlan(enrollmentData).subscribe((result: any) => {
              //this.consoleMessage(result)
            })
          }
          else {
            this.paymenttransactionResponse = true
            this.visible = true
            this.showbuttons = false
            this.failedarray.push("CCFailed")
            sessionStorage.setItem("failed", JSON.stringify(this.failedarray))
            let inputData = JSON.parse(sessionStorage.getItem("Data") || '[]');

            let enrollmentData = {
              "customerName": inputData.firstName + "" + inputData.lastName,
              "contactNum": inputData.phone_number,
              "dob": inputData.date_of_birth,
              "email": inputData.email,
              "process": "enrollmentSummary",
              "request": { "paymentMethod": "CC", "signature": sessionStorage.getItem("signature") || "", "paymentMethodId": 0 }
            }

            this._SignupformService.savePlan(enrollmentData).subscribe((result: any) => {
              //this.consoleMessage(result)
            })
          }


        }

        else {
          this.paymenttransactionResponse = true
          this.visible = true
          this.showbuttons = false
        }


        let personalInfo = JSON.parse(sessionStorage.getItem("Data") || '[]')
        let customerId = sessionStorage.getItem("customerId")
        // let publicApiKey  =JSON.parse(sessionStorage.getItem("publicApiKey"))
        let billingpostalcode = sessionStorage.getItem("billingpostalcode")
        let billingprovincelist = sessionStorage.getItem("billingprovincelist")
        let billingaddresscity = sessionStorage.getItem("billingaddresscity")
        let addressline2 = sessionStorage.getItem("addressline2")
        let addressline1 = sessionStorage.getItem("addressline1")


        let billingAddressData = {}

        if (sessionStorage.getItem("homeAddress") == "true") {
          //       billingAddressData= {
          //         "customer_id": sessionStorage.getItem("customerid"),
          //         "fusebill_customer_id": sessionStorage.getItem("fusebillCustomerId"),
          //         "line1": "",
          //         "line2": "",
          //         "city": "",
          //         "state": "",
          //         "state_id": "",
          //         "country": "",
          //         "country_id": "",
          //         "postal_zip":""
          // }
          billingAddressData = {}

        }
        else {
          billingAddressData = JSON.parse(sessionStorage.getItem("billingAddress") || '{}')

        }

        let bankdetailsobj = sessionStorage.getItem("bankDetails")

        // let bankdetails ={
        //   "bankCode": bankdetailsobj[0].bankcode,
        //   "branchCode":this.bankpayForm.get('branchcode').value,
        //   "bankName":this.bankpayForm.get('bankname').value,
        //   "accountNumber":this.bankpayForm.get('accountnumber').value

        // }


        this.countries = JSON.parse(sessionStorage.getItem("countrydetails") || '[]')

        this.countries?.forEach((element: any) => {
          this.currency = element.currency
          this.currencySymbol = element.currencySymbol
        })
        // parseFloat(sessionStorage.getItem("totalAmount"))
        // "greenshieldRegistration" : true,
        // "equitableRegistration": true,  //false   //true
        // "billing_sameas_homeAddress": sessionStorage.getItem("homeAddress")=="true"?true:false,
        // "billing_address":billingAddressData,
        let summary = JSON.parse(sessionStorage.getItem("plansummary") || '[]')
        var formData: any = new FormData();
        let inputData = {

          "customerId": parseInt(sessionStorage.getItem("normalcustomerid") || ''),
          "fusebill_customerId": parseInt(sessionStorage.getItem("customerId") || ''),
          "fusebill_paymentMethodId": parseInt(params['paymentMethodId']) || 0,

          "enrollmentDate": sessionStorage.getItem("enrollmentdate"),
          "add_address_toTaxation": false,
          "totalAmount": sessionStorage.getItem("totalAmount"),

          "plans": summary,
          "currency": "CAD",
          "currencySymbol": "$",

          "totalAmountUI": sessionStorage.getItem("totalAmountUI"),
          "stateId": parseInt(sessionStorage.getItem("stateid") || ''),
          "signature": sessionStorage.getItem("signature") || "",
          "fusebill_paymentMethod": sessionStorage.getItem("paymentMethod")  // "CC"

        }



        // for (const a of summary) {
        //   //this.consoleMessage(typeof a)
        //   //this.consoleMessage(a)


        // }

        let plans: any = []

        this.plansummaryMain = JSON.parse(sessionStorage.getItem("plansummarymain") || '[]')
        this.plansummaryLIFE = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '[]')
        let planDetailsArrayBlock = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '[]')

        let vikingSignup = JSON.parse(sessionStorage.getItem("isVikingSignup") ?? "false");



        this.plansummaryLIFE.forEach((element: any, index: number) => {

          element.member.maximumCoverageWithoutEvidence = element.member.defaultRange

          if (element.spouse && element.spouse.maximumCoverageWithoutEvidence) {
            element.spouse.maximumCoverageWithoutEvidence = element.spouse.defaultRange
          }
          element['amount'] = element.guaranteedAcceptanceDetails.amount
          element['amountUI'] = "$" + element.guaranteedAcceptanceDetails.amount
          element['planPrice'] = element.guaranteedAcceptanceDetails.amount
          element['total'] = element.guaranteedAcceptanceDetails.total
          element['totalPrice'] = element.guaranteedAcceptanceDetails.total
          element['skuTotalPrice'] = element.guaranteedAcceptanceDetails.total
          element['totalUI'] = "$" + element.guaranteedAcceptanceDetails.total
          element['tax'] = element.guaranteedAcceptanceDetails.tax
          element['taxUI'] = "$" + element.guaranteedAcceptanceDetails.tax
          this.plansummaryLIFEFinal.push(element)

        });
        planDetailsArrayBlock?.forEach((element: any, index: number) => {
          if (element.id == 13) {
            this.iafgPlansAvailability = true
          }
          else {
            this.iafgPlansAvailability = false
          }

        });

        this.plansummary = this.plansummaryMain.concat(this.plansummaryLIFEFinal)
        console.log(this.plansummary)
        this.plansummary = this.plansummary.sort(function (a: any, b: any) {
          return (a.packageId - b.packageId);
        })

        let taxesInfo = {}
        this.plansummary?.forEach((element: any) => {

          if (element.packageId == 1) {
            this.provisioning = true
          }

          element.totalPrice = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
          element.total = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
          element.tax = this._decimalPipe.transform(element.tax, "1.2-2")?.replace(/,/g, "")
          element.amount = this._decimalPipe.transform(element.amount, "1.2-2")?.replace(/,/g, "")
          taxesInfo = this.determineTaxes(element?.products?.[0]?.calculatedTax?.planProductInfos ?? [])
          // element = { ...element, taxesInfo }
          element.taxApplicable = element.tax > 0
          Object.assign(element, taxesInfo);

          console.log(element)
          console.log(taxesInfo)


          if(element.planLevel == 15){
            let multiPlanCount = JSON.parse(sessionStorage.getItem("multiPlanCount") ?? "0");
            if (multiPlanCount > 0) {
              let planScopeDetails = JSON.parse(sessionStorage.getItem("planScopeDetails") ?? "[]");
              element.count = multiPlanCount
              element.planScopeDetails = planScopeDetails
            }
          }


          if(vikingSignup){
            let planScopeDetails = JSON.parse(sessionStorage.getItem("planScopeDetails") ?? "[]");
            element.planScopeDetails = planScopeDetails
          }


          if(element.id == 908){
            let questionnarireRaw = sessionStorage.getItem("allstate_questionnaire");
            let recordedQuestionnarireRaw = sessionStorage.getItem("recordedData");

            if(questionnarireRaw){
              let questionnarire = JSON.parse(questionnarireRaw ?? "{}");
              let finalObj:any = {};

              let objkeys = Object.keys(questionnarire.answers);
              for(const key_ of objkeys){
                if(!finalObj[key_]){
                  finalObj[key_] = questionnarire.answers[key_]['value']
                }
              }
               element.allstateQuestionnaire = finalObj
            }

             if(recordedQuestionnarireRaw){
              let questionnarire = JSON.parse(recordedQuestionnarireRaw ?? "{}");
              let finalObj:any = {};

              let objkeys = Object.keys(questionnarire.userAnswers);

              // allstateEOI1 is always true; all other keys default to false then update from answers
              finalObj['allstateEOI1'] = true;
              for (const key_ of objkeys) {
                if (key_ !== 'allstateEOI1') {
                  finalObj[key_] = questionnarire.userAnswers[key_]['value'] ?? false;
                }
              }

              //  element.recordedAllstateQuestionnaire = finalObj
               element.allstateQuestionnaire = finalObj
               element.userOptedCoverage = questionnarire?.userOptedCoverage ?? 50000
            }
          }

          plans.push(element)
        });


        formData.append("plans", JSON.stringify(plans));
        formData.append("customerId", parseInt(sessionStorage.getItem("customerId") || '0') ?? 0);
        formData.append("fusebill_customerId", parseInt(sessionStorage.getItem("fusebillCustomerId") || '0')) ?? 0;
        formData.append("fusebill_paymentMethodId", parseInt(params['paymentMethodId']) || 0);
        formData.append("enrollmentDate", sessionStorage.getItem("enrollmentdate"));
        formData.append("add_address_toTaxation", false);
        formData.append("totalAmount", sessionStorage.getItem("totalAmount"));
        formData.append("currency", "CAD");
        formData.append("currencySymbol", "$");
        formData.append("totalAmountUI", sessionStorage.getItem("totalAmountUI"));
        formData.append("stateId", parseInt(sessionStorage.getItem("stateid") || '1'));
        formData.append("signature", sessionStorage.getItem("signature") || "");
        formData.append("failed", sessionStorage.getItem("failed") || "[]");
        formData.append("fusebill_paymentMethod", sessionStorage.getItem("paymentMethod"));
        formData.append("timestamp", new Date().getTime());
        formData.append("firstName", personalInfo?.firstName);
        formData.append("lastName", personalInfo?.lastName);
        formData.append("email", personalInfo?.email);
        formData.append("userKey", sessionStorage.getItem("userKey"));
        formData.append("iafgPlansAvailability", this.iafgPlansAvailability);






        if (sessionStorage.getItem("paymentMethod") == "CC") {

        } else {
          formData.append("padFilename", sessionStorage.getItem("filename") + ".pdf");
          formData.append("session", sessionStorage.getItem("session")) || "";
          formData.append("files", this.uploadfile) || "";
        }


        // if(sessionStorage.getItem("Demoform")=="true"){
        //   // this.demovalue="test/ROE"

        //   this.demovalue="v2/subscription"

        // }
        // else{
        //   this.demovalue="v2/subscription"
        // }

        let multiPlanCount = JSON.parse(sessionStorage.getItem("multiPlanCount") ?? "0");
        if (multiPlanCount > 0) {
          let planScopeDetails = sessionStorage.getItem("planScopeDetails") ?? "[]";
          formData.append("count", multiPlanCount)
          formData.append("planScopeDetails", planScopeDetails)
        }
        console.log('v5Api', v5Api)
        if (v5Api == true) {
          this.demovalue = "v5/subscription"

          if (vikingSignup) {
            let planScopeDetails = sessionStorage.getItem("planScopeDetails") ?? "[]";
            if(planScopeDetails){
              formData.append("planScopeDetails", planScopeDetails)
            }
            this.demovalue = "generic/v5/subscription";
          } 

          formData.append('taxes', [])
          formData.append('paymentPlatform', 'AuthorizeNet')
          let authorizenetPaymentId = sessionStorage.getItem('authorizenetPaymentId')
          formData.append('authorizeNetCustomerProfileId', sessionStorage.getItem('authorizenetCustomerId'))
          formData.append('authorizeNetPaymentProfileId', !!authorizenetPaymentId && authorizenetPaymentId != 'null' ? authorizenetPaymentId : '')
          // formData.append('customerPaymentMethod', sessionStorage.getItem('payment')=='CC'?'CC':sessionStorage.getItem('payment')=='PAD'?'PAD':'')// defeault CC
          formData.append('customerPaymentMethod', sessionStorage.getItem("paymentMethod") == 'CC' ? 'CC' : sessionStorage.getItem("paymentMethod") == 'PAD' ? 'PAD' : '')// defeault CC

          // remove session storage values
          // sessionStorage.removeItem('authorizenetCustomerId')
          // sessionStorage.removeItem('authorizenetPaymentId')
          // sessionStorage.removeItem('payment')
        } else {
          this.demovalue = "v4/subscription"
        }

        let activity: any = {};
        activity.action = 'Step 7 of 7 - Customer subscription';
        activity.url = environment.app.grp + "api/customer/" + this.demovalue;
        activity.requestMethod = 'POST';
        activity.effectedUserId = customerId;
        activity.requestBody = JSON.stringify(formData);

        if (customerId == '0') {
          // Swal.fire({title:'Info',text:'Invalid customer ID'})

          activity.status = 'FAILURE';
          activity.response = {};
          activity.responseSummary = 'Found customer id as 0';
          // this._SignupformService.buildActivityLogObject(activity, true);

          let log = {
            api: environment.app.grp + "api/customer/" + this.demovalue,
            payload: JSON.stringify(formData),
            message: `Found customer Id as 0`,
            portal: 'Corporate Signup form'
          }
          let obj = {
            customerDetails: JSON.stringify({ username: personalInfo?.email, timeStamp: sessionStorage.getItem('timeStamp') }),
            logs: JSON.stringify(log),
          };
          this._SignupformService.submitReportLog(environment.app.commonurl, obj);

          this.ShowModelPopup = true
          this.ShowModelPopupMessage = 'Sorry for the inconvenience! An unexpected error occurred. Your information is safely stored, we will contact you once it got resolved.';
          this.ShowModelPopupTitle = 'Error';
          return;
        }

        var requestOptions: any = {

          method: 'POST',
          body: formData,
          redirect: 'follow'

        };


        if (!sessionStorage.getItem("subscriptionCalled") || sessionStorage.getItem("subscriptionCalled") != "1") {
          sessionStorage.setItem("subscriptionCalled", "1")

          fetch(environment.app.grp + "api/customer/" + this.demovalue + "", requestOptions)

            .then(response => response.text())

            .then((resposne: any) => {//this.consoleMessage(resposne)
              resposne = JSON.parse(resposne)
              //this.consoleMessage(resposne.status)
              if (resposne.status == 200) {
                activity.status = 'SUCCESS';
                activity.response = resposne;
                activity.responseSummary = 'Customer subscription successful';
                // this._SignupformService.buildActivityLogObject(activity, true);

                this.customerLink = resposne.customerPortalLink
                this.paymenttransactionResponse = false
                this.paymentSucessResponse = true
                this.visible = false
                this.provisioning = false
                this.showbuttons = true


                this.subscriptiondetails = resposne.data
                if (sessionStorage.getItem("Demoform") == "true") {
                  this.responsevalue = resposne.message

                }
                else {
                  this.responsevalue = "Thank you for your enrollment! Please check your inbox for the welcome email. Log in to your Member Portal and set your password."
                  // this.responsevalue=this.lang["enrollment_success"]
                  // this.responsevalue=`Thank you for your enrollment!  Please check your inbox for your welcome email. Login to your Member Portal using the activation code in the welcome email and update the password.`
                  // this.responsevalue=this.lang.Thank_you_for_your_enrollment_Please_check_your_inbox_for_your_welcome_email_Login_to_your_Member_Portal_using_the_activation_code_in_the_welcome_email_and_update_the_password
                  // this.responsevalue=`Thank you for your enrollment!  Please check your inbox for your Welcome email. Login to your Member Portal using the activation code in the Welcome email and update the password.`
                }

                fetch(environment.app.adminPortal + "/api/ap/global/set-adminCorporates", {
                  // Adding method type
                  method: "GET",
                  // Adding body or contents to send
                  headers: {
                    "Content-type": "application/json; charset=UTF-8"
                  }
                })
                fetch(environment.app.adminPortal + "/api/ap/global/set-adminMembers", {
                  // Adding method type
                  method: "GET",
                  // Adding body or contents to send
                  headers: {
                    "Content-type": "application/json; charset=UTF-8"
                  }
                })

                fetch(environment.app.adminPortal + "/api/ap/global/set-adminAdvisors", {
                  // Adding method type
                  method: "GET",
                  // Adding body or contents to send
                  headers: {
                    "Content-type": "application/json; charset=UTF-8"
                  }
                })

                this.showEnrollmentModel = true
                this.showHeaderMessage = this.lang.Enrollment_successful ?? 'Enrollment successful'
                this.showModelContent = this.responsevalue

                // sessionStorage.clear()
                // sessionStorage.removeItem("subscriptionCalled")

              }

              else {
                this.paymenttransactionResponse = false

                this.showEnrollmentModel = true
                this.showHeaderMessage = resposne.message ? resposne.message : resposne.error,
                  this.showModelContent = this.responsevalue

                // sessionStorage.clear()
                sessionStorage.setItem("paymentfail", "1")
                // sessionStorage.removeItem("subscriptionCalled")

                activity.status = 'FAILURE';
                activity.response = resposne;
                activity.responseSummary = 'Customer subscription failed';
                // this._SignupformService.buildActivityLogObject(activity, true);

              }

            })
            .catch(error => {//this.consoleMessage('error', error)

              if ([0, 500, 501, 502, 503].includes(error.status)) {

                this.ShowModelPopup = true
                this.ShowModelPopupMessage = this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.',
                  this.ShowModelPopupTitle = this.lang?.Info ?? 'Info'

                activity.status = 'FAILURE';
                activity.response = error;
                activity.responseSummary = 'Customer subscription failed';
                // this._SignupformService.buildActivityLogObject(activity, true);

                // create object for report log
                let currentTimeStamp = new Date().getTime().toString();
                let log = {
                  api: environment.app.grp + "api/corporate/customer/" + this.demovalue + "",
                  payload: JSON.stringify(formData),
                  message: this.lang?.Sorry_the_server_is_currently_undergoing_maintenance_Please_try_again_later_We_apologize_for_any_inconvenience ?? 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.' + " " + currentTimeStamp,
                  portal: 'Gig Signup form'
                }

                let obj = {
                  customerDetails: JSON.stringify({ username: personalInfo.email, timeStamp: sessionStorage.getItem('timeStamp') }),
                  logs: JSON.stringify(log),
                };
                this._SignupformService.submitReportLog(environment.app.commonurl, obj);
              }
              else {

                activity.status = 'FAILURE';
                activity.response = error;
                activity.responseSummary = 'Customer subscription failed';
                // this._SignupformService.buildActivityLogObject(activity, true);

                this.ShowModelPopup = true
                this.ShowModelPopupMessage = error.error.message ? error.error.message : error.error.error,
                  this.ShowModelPopupTitle = this.lang.Info

                // create object for report log
                let currentTimeStamp = new Date().getTime().toString();
                let log = {
                  api: environment.app.grp + "api/corporate/customer/" + this.demovalue + "",
                  payload: JSON.stringify(formData),
                  message: `Trying to submit subscription form again ${currentTimeStamp}`,
                  portal: 'Gig Signup form'
                }

                let obj = {
                  customerDetails: JSON.stringify({ username: personalInfo.email, timeStamp: sessionStorage.getItem('timeStamp') }),
                  logs: JSON.stringify(log),
                };
                this._SignupformService.submitReportLog(environment.app.commonurl, obj);
              }

            });
        }
        else {
          this.paymenttransactionResponse = false
          this.visible = false
          this.provisioning = false

          this.ShowModelPopup = true
          this.ShowModelPopupMessage = this.lang.You_are_already_done_with_the_subscription_Please_check_your_mail_or_contact_admin_groupbenefitz_ca ?? 'You are already done with the subscription.Please check your mail or contact admin@groupbenefitz.ca',
            this.ShowModelPopupTitle = this.lang.Info ?? 'Info'

          // create object for report log
          let currentTimeStamp = new Date().getTime().toString();
          let log = {
            api: environment.app.grp + "api/corporate/customer/" + this.demovalue + "",
            payload: JSON.stringify(formData),
            message: `Trying to submit subscription form again ${currentTimeStamp}`,
            portal: 'Gig Signup form'
          }

          let obj = {
            customerDetails: JSON.stringify({ username: personalInfo.email, timeStamp: sessionStorage.getItem('timeStamp') }),
            logs: JSON.stringify(log),
          };
          this._SignupformService.submitReportLog(environment.app.commonurl, obj);
        }



      })

    }
    else {
      this.paymenttransactionResponse = false
      this.visible = false
      this.provisioning = false

      this.ShowModelPopup = true
      this.ShowModelPopupMessage = this.lang.You_are_already_done_with_the_subscription_Please_check_your_mail_or_contact_admin_groupbenefitz_ca,
        this.ShowModelPopupTitle = this.lang.Info


      // return false
    }

  }

  public determineTaxes(taxArray: any) {
    let taxObj: any = {
      pst: null,
      pstTaxRate: null,
      hst: null,
      hstTaxRate: null,
      gst: null,
      gstTaxRate: null,
      taxName: null,
      taxPrice: null
    };

    for (let tax of taxArray) {
      if (!taxObj.taxName || taxObj.taxName == null) {
        taxObj.taxName = "";
      }

      if (tax.name.includes("PST") || tax.name.includes("Prov")) {
        taxObj.pst = tax.price + (taxObj.pst ?? 0);
        taxObj.pstTaxRate = (tax.taxRate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("HST")) {
        taxObj.hst = tax.price + (taxObj.hst ?? 0);
        taxObj.hstTaxRate = (tax.taxRate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("GST")) {
        taxObj.gst = tax.price + (taxObj.gst ?? 0);
        taxObj.gstTaxRate = (tax.taxRate) * 100;
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
    }
    taxObj.taxName = taxObj.taxName?.trim();
    if (taxObj.taxName && taxObj.taxName[taxObj.taxName.length - 1] == "|") {
      taxObj.taxName = taxObj.taxName.slice(0, -1);
      taxObj.taxName = taxObj.taxName?.trim();
    }

    if (taxObj.pst || taxObj.hst || taxObj.gst) {
      taxObj.taxPrice = 0;
      taxObj.taxPrice = (taxObj.pst ?? 0) + (taxObj.hst ?? 0) + (taxObj.gst ?? 0)
    }

    return taxObj;
  }


  // public getLanguageTokens() {
  //   let body = {
  //     "project": "SignupForm",
  //     "url": "GIGPayment"
  //   }
  //   this.http
  //     .post(environment.app.langApi + 'string/project-url-strings', body, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         console.log(response)
  //         this.lang = {};
  //         this.languageData = response.strings??[]
  //         this.selectedLanguage = sessionStorage.getItem("language")
  //         for (let token of response.strings) {
  //           this.lang[token.key] = token[this.selectedLanguage];
  //         }

  //       })
  // }
  public getLanguageTokens() {
    let body = {
      "project": "SignupForm",
      "url": "GIGPayment"
    }
    this.http
      .post(environment.app.langApi + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (!response || !response.strings || response.strings.length === 0) {
            // fallback to local language strings
            this.loadLocalLanguageStrings();
          } else {
            this.setupLanguage(response.strings);
          }
        },
        (error) => {
          // on error, also fallback to local strings
          this.loadLocalLanguageStrings();
        }
      )
  }

  private loadLocalLanguageStrings() {
    this.setupLanguage(strings);
  }

  private setupLanguage(strings: any[]) {
    this.lang = {};
    this.languageData = strings;
    this.selectedLanguage = sessionStorage.getItem("language");

    for (let token of strings) {
      this.lang[token.key] = token[this.selectedLanguage];
    }
  }

  closeModelpopup() {
    this.showEnrollmentModel = false
    window.open(this.customerLink)
    // console.log(args)
  }
  postAnalyticsData() {
    var pageName = sessionStorage.getItem("pageName");
    if (
      sessionStorage.getItem("ipaddress")

    ) {
      fetch(environment.app.grp + "api/common/analytics", {
        method: "POST",

        body: JSON.stringify({
          ipAddress: sessionStorage.getItem("ipaddress"),
          timestamp: sessionStorage.getItem("timeStamp"),
          pageName: pageName ? pageName : "PersonalInfo",
          gbReferer: window.document.referrer || "",
          pageUrl: window.location.href,
        }),

        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
    }
  }


  public gotohomepage() {
    this.router.navigate(['/signup']);
  }

  public printpage() {
    window.print();
  }
  onClosedModelpopup(confirmed: boolean) {
    if (confirmed) {
      this.ShowModelPopup = false;
      this.showEnrollmentModel = false;
    } else {
      this.ShowModelPopup = false;
      this.showEnrollmentModel = false;
    }
  }
}
